<div class="my-account">
  <h1 class="title">
    @if (greetingName) {
      <strong class="title__desktop">{{ 'pages.myAccount.greetingPrefix' | i18n }}</strong
      >{{ ' '
      }}<strong class="title__name title__desktop">{{
        'pages.myAccount.greetingName' | i18n: { name: greetingName }
      }}</strong>
    } @else {
      <strong class="title__desktop">{{ 'pages.myAccount.greetingFallback' | i18n }}</strong>
    }
    <strong class="title__mobile">{{ 'pages.myAccount.mobileTitle' | i18n }}</strong>
  </h1>

  <section class="section">
    <h2 class="section__title">{{ 'pages.myAccount.sectionTitle' | i18n }}</h2>
    <p class="section__body">{{ 'pages.myAccount.sectionBody' | i18n }}</p>
  </section>

  <div class="shortcuts-grid">
    @if (ordersRoute) {
      <umkt-account-card
        [icon]="{ name: 'documento', type: 'mondrian-icons' }"
        [title]="'shared.labels.orders' | i18n"
        [description]="'pages.myAccount.orders.description' | i18n"
        [route]="ordersRoute || '#'"
      >
      </umkt-account-card>
    }

    @if (showPendingOrdersCard) {
      <umkt-account-card
        [icon]="{ name: 'circulo-exclamacao', type: 'mondrian-icons' }"
        [title]="'pages.myAccount.pendingOrders.title' | i18n"
        [description]="'pages.myAccount.pendingOrders.description' | i18n"
        [route]="pendingOrdersRoute"
        [badgeCount]="pendingOrdersCount"
      >
      </umkt-account-card>
    }

    @if (!ordersRoute) {
      <div class="account-card loading">
        <div class="icon-container">
          <umkt-icon [icon]="{ name: 'documento', type: 'mondrian-icons' }" [size]="'lg'"></umkt-icon>
        </div>
        <div class="content">
          <h3>{{ 'shared.labels.orders' | i18n }}</h3>
          <p>{{ 'shared.messages.loading' | i18n }}</p>
        </div>
      </div>
    }

    <umkt-account-card
      [icon]="{ name: 'estrela-vazia', type: 'mondrian-icons' }"
      [title]="'shared.labels.plans' | i18n"
      [description]="'pages.myAccount.plans.description' | i18n"
      [route]="plansRoute"
    >
    </umkt-account-card>

    <umkt-account-card
      [icon]="{ name: 'empresa', type: 'mondrian-icons' }"
      [title]="'pages.myAccount.details.title' | i18n"
      [description]="'pages.myAccount.details.description' | i18n"
      route="/my-account/account-details"
    >
    </umkt-account-card>
  </div>

  <router-outlet></router-outlet>
</div>
